import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ProjectLayoutService } from '../../project-layout.service';

@Component({
  selector: 'app-dashboard-header',
  templateUrl: './dashboard-header.component.html',
  styleUrls: ['./dashboard-header.component.scss'],
})
export class DashboardHeaderComponent implements OnInit {
  constructor(public projectLayoutService: ProjectLayoutService) {}

  @Output() mainMenuIconClicked: EventEmitter<any> = new EventEmitter<any>();
  @Input() isMenuNeeded: boolean = false;

  ngOnInit(): void {}

  toggleDashboardMenu(): void {
    this.projectLayoutService.toggleDashboardMenu();

    this.mainMenuIconClicked.emit();
  }
}
